import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectLoggedIn,
  selectUserRole,
  selectEmailVerified,
} from "../../store/slices/auth/slice";
import { ROLES, ROUTES, ACCESS } from "../../utils/constants";
import LoadingScreen from "../utils/LoadingScreen";

// Helpers
const isAdminRole = (role) =>
  role === ROLES.ADMIN || role === ROLES.SUPER_ADMIN;

const getDashboardPath = (role) =>
  isAdminRole(role) ? ROUTES.ADMIN_OVERVIEW : ROUTES.USER_WORKSHOPS;

const ProtectedRoute = ({
  children,
  access = ACCESS.AUTHENTICATED,
  allowEmailVerification = false,
}) => {
  const isLoggedIn = useSelector(selectLoggedIn);
  const userRole = useSelector(selectUserRole);
  const emailVerified = useSelector(selectEmailVerified);

  // 1. Loading
  if (isLoggedIn === null) {
    return <LoadingScreen />;
  }

  // 2. Public routes (login, register) - redirect ako ulogovan
  if (access === ACCESS.PUBLIC) {
    // Allow email verification page even if logged in
    if (allowEmailVerification) {
      return children;
    }
    return isLoggedIn ? (
      <Navigate to={getDashboardPath(userRole)} replace />
    ) : (
      children
    );
  }

  // 3. Nije ulogovan
  if (!isLoggedIn) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // 4. Treba verifikacija email-a
  const needsVerification = [ACCESS.VERIFIED, ACCESS.USER_ONLY].includes(
    access
  );

  if (needsVerification && !emailVerified) {
    return <Navigate to={ROUTES.EMAIL_VERIFICATION_NOTICE} replace />;
  }

  // 5. Provera uloge
  const hasAccess = (() => {
    switch (access) {
      case ACCESS.SUPER_ADMIN:
        return userRole === ROLES.SUPER_ADMIN;
      case ACCESS.ADMIN:
        return isAdminRole(userRole);
      case ACCESS.USER_ONLY:
        return !isAdminRole(userRole);
      default:
        return true;
    }
  })();

  if (!hasAccess) {
    return <Navigate to={getDashboardPath(userRole)} replace />;
  }

  return children;
};

export default ProtectedRoute;
